import { classesBuilder } from '@common/helpers';
import { formatSectionId } from '@components/Sidebar/helpers';

import { useCardFlashlightHoverHandlers, useMergedHandlers } from './hooks';
import type { ICardProps } from './types';

import style from './styles.module.scss';

const Card = ({ label, value, children, icon, className, onMouseMove, onMouseLeave, ...props }: ICardProps) => {
  const { onMouseMove: defaultOnMouseMove, onMouseLeave: defaultOnMouseLeave } = useCardFlashlightHoverHandlers();
  const handleMouseMove = useMergedHandlers(defaultOnMouseMove, onMouseMove);
  const handleMouseLeave = useMergedHandlers(defaultOnMouseLeave, onMouseLeave);

  const wrapperClass = classesBuilder(style.wrapper, className, {
    [style['is-container']]: Boolean(children),
  });

  return (
    <div
      id="card"
      className={wrapperClass}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {/* If children exist, treat the card as a flexible container. */}
      {children ? (
        children
      ) : (
        <>
          {(label || icon) && (
            <div className={style['header-container']}>
              {icon && <div className={style.icon}>{icon}</div>}
              {label && (
                <div
                  id="card-label"
                  className={style.label}
                >
                  {formatSectionId(label)}
                </div>
              )}
            </div>
          )}
          {value && (
            <div
              id="card-value"
              className={style.value}
            >
              {formatSectionId(value)}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Card;
